"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const modal_1 = require("./modal");
const { ModalFooter } = require("@atlaskit/modal-dialog");
const button_1 = require("@atlaskit/button");
const form_1 = require("../form");
class Container extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { onSubmit, className, children } = this.props;
        return (React.createElement(form_1.Form, { onSubmit: onSubmit, className: className }, children));
    }
}
class Footer extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { showKeyline, actions } = this.props;
        return (React.createElement(ModalFooter, { showKeyline: showKeyline },
            React.createElement("span", null),
            React.createElement(button_1.ButtonGroup, null,
                actions.submit ? (React.createElement(form_1.FormButton, { appearance: "primary", type: "submit" }, actions.submit.text)) : null,
                React.createElement(form_1.FormButton, { onClick: actions.close.onClose }, actions.close.text))));
    }
}
class FormModal extends React.Component {
    constructor() {
        super(...arguments);
        this.onSubmit = (data) => __awaiter(this, void 0, void 0, function* () { return this.props.actions.submit.onSubmit(data); });
    }
    render() {
        const { actions } = this.props;
        return (React.createElement(modal_1.Modal, Object.assign({}, this.props, { actions: undefined, components: {
                Container: ({ children, className }) => (React.createElement(Container, { onSubmit: this.onSubmit, className: className }, children)),
                Footer: ({ showKeyline }) => (React.createElement(Footer, Object.assign({}, this.props, { showKeyline: showKeyline, actions: actions })))
            } })));
    }
}
exports.FormModal = FormModal;
